import { EditContainer } from 'features/globalSetup/forms/Prebid/Modules/VendorSpecificForm/GeneralForm'

export const GeneralPage = (): JSX.Element => {
  return <EditContainer />
}
